import MitLandingPage from '../pages/MitLandingPage.vue';

//USER
import MitDashboardPage from '../pages/MitDashboardPage.vue';
import MitFindLabMemberPage from '../pages/MitFindLabMemberPage.vue';
import MitMyActionsRequiredPage from '../pages/my/MitMyActionsRequiredPage.vue';
import MitMyReqeustsPage from '../pages/my/MitMyReqeustsPage.vue';
import MitMyInfoPage from '../pages/my/MitMyInfoPage.vue';
import MitHomePage from '../pages/MitHomePage.vue';


// import MitMyReservationsPage from '../pages/MitMyReservationsPage.vue';
// import MitReservePage from '../pages/MitReservePage.vue';
// import MitSettingsPage from '../pages/MitSettingsPage.vue';

//HR
import MitHRDashboardPage from '../pages/hr/MitHRDashboardPage.vue';
import MitHRManagePeoplePage from '../pages/hr/MitHRManagePeoplePage.vue';
import MitHRManagePeoplePage2 from '../pages/hr/MitHRManagePeoplePage2.vue';
import MitHRRoomAssignmentsPage from '../pages/hr/MitHRRoomAssignmentsPage.vue';

//ACTIONS
import MitActionNewPersonPage from '../pages/actions/MitActionNewPersonPage.vue';
import MitActionNewPersonWizardPage from '../pages/actions/MitActionNewPersonWizardPage.vue';
import MitActionNewPersonContinuePage from '../pages/actions/MitActionNewPersonContinuePage.vue';

import MitActionEditPersonPage from '../pages/actions/MitActionEditPersonPage.vue';
import MitActionRemovePersonPage from '../pages/actions/MitActionRemovePersonPage.vue';
// import MitManageReservationsSetupPage from '../pages/manage/MitManageReservationsSetupPage.vue';
// import MitManageAuditPage from '../pages/manage/MitManageAuditPage.vue';
// import MitManagerDashboardPage from '../pages/manage/MitManagerDashboardPage.vue';



//ADMIN
import MitAdminPage from '../pages/admin/MitAdminPage.vue';
// import MitAdminReservableSpacesPage from '../pages/admin/MitAdminReservableSpacesPage.vue';
// import MitAdminImportReservationsPage from '../pages/admin/MitAdminImportReservationsPage.vue';


export const defaultRoute = 'hr-dashboard';

export function getAppRoutes(MitUserModel, routerGuardAccessCheck) {
  return [
    {
        path: '/landing',
        name: 'landing',
        component: MitLandingPage
    },
    {
        path: '/home',
        name: 'home',
        component: MitHomePage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
    },
    {
      path: '/find',
      name: 'find',
      component: MitFindLabMemberPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
      },
    },
    {
      path: '/my/info',
      name: 'my-info',
      component: MitMyInfoPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
        routerGuardAccessCheck(to, from, next);
      },
    },
    {
        path: '/my/actions',
        name: 'my-actions',
        component: MitMyActionsRequiredPage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        },
      },
      {
        path: '/my/requests',
        name: 'my-requests',
        component: MitMyReqeustsPage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        },
      },
    //****** HR ******/
    {
        path: '/hr/dashboard',
        name: 'hr-dashboard',
        component: MitHRDashboardPage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
    },
    {
      path: '/hr/manage/people',
      name: 'hr-manage-people',
      component: MitHRManagePeoplePage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/hr/manage/people2',
      name: 'hr-manage-people2',
      component: MitHRManagePeoplePage2,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/hr/manage/spaces',
      name: 'hr-manage-spaces',
      component: MitHRRoomAssignmentsPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    //****** ACTIONS ******/
    {
        path: '/action/new/person',
        name: 'hr-action-new-person',
        component: MitActionNewPersonPage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
            routerGuardAccessCheck(to, from, next);
        }
    },
    {
      path: '/action/new/person/steps',
      name: 'hr-action-new-person-steps',
      component: MitActionNewPersonWizardPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
  },
    {
      path: '/action/continue/person',
      name: 'hr-action-continue-person',
      component: MitActionNewPersonContinuePage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/action/edit/person',
      name: 'action-edit-person',
      component: MitActionEditPersonPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/action/remove/person',
      name: 'action-remove-person',
      component: MitActionRemovePersonPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    //****** ADMIN ******/
    {
        path: '/admin',
        name: 'admin',
        component: MitAdminPage,
        meta: { allowedRole: MitUserModel.ROLES.ADMIN },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
      }
  ];
}
